import PrimeVueStyled from 'primevue/config';
import { definePreset } from '@primeuix/themes';

import SeyboldTheme from '@/theme';

import de from '../locales/de.json';
import en from '../locales/en.json';
import fr from '../locales/fr.json';
import hu from '../locales/hu.json';

interface TranslationJSON {
  [key: string]: any;
}

interface PrimeVueLocale {
  firstDayOfWeek: number;
  dayNames: string[];
  dayNamesShort: string[];
  dayNamesMin: string[];
  monthNames: string[];
  monthNamesShort: string[];
  today: string;
  clear: string;
}

const deLocale: TranslationJSON = de;
const enLocale: TranslationJSON = en;
const frLocale: TranslationJSON = fr;
const huLocale: TranslationJSON = hu;

export const primevue = PrimeVueStyled;

const SeyboldPreset = definePreset(SeyboldTheme);

export const primevueConfig = {
  pt: {
    inputtext: {
      root: 'w-full my-2',
    },
    select: {
      root: 'w-full my-2',
    },
    textarea: {
      root: 'w-full my-2',
    },
    autocomplete: {
      root: 'w-full',
    },
    unmaskicon: {
      class: 'top-[35%]',
    },
    form: {
      class: 'text-iconred-500',
    },
    mainMenuPanel: {
      root: {
        class: 'px-2',
      },
      panel: {
        class: 'bg-transparent border-0',
      },
      header: {
        label: {
          class: 'text-iconred-500',
        },
      },
      rootList: {
        class: 'pl-0',
      },
    },
    subMenu: {
      class: 'px-0 pb-3',
    },
  },
  theme: {
    preset: SeyboldPreset,
    options: {
      darkModeSelector: '[data-theme="dark"]',
      cssLayer: {
        name: 'primevue',
        order: 'base, primevue, utilities',
      },
    },
  },
};

function getPrimeVueLocale(locale: string): PrimeVueLocale {
  switch (locale) {
    case 'de':
      return deLocale.primevue;
    case 'en':
      return enLocale.primevue;
    case 'fr':
      return frLocale.primevue;
    case 'hu':
      return huLocale.primevue;
    default:
      return deLocale.primevue;
  }
}

export function getPrimeVueConfigWithLocale(lang: string) {
  return {
    ...primevueConfig,
    locale: getPrimeVueLocale(lang),
  };
}
